module.exports = __webpack_public_path__ + "img/cytomine-ee.cc284dfd.svg";